module.exports = __webpack_public_path__ + "static/media/send.9cdfe29a.svg";